import { NavigateFunction, useNavigate } from "react-router-dom";
import { randomBackgroundPosition } from "./TemplatesBox";

import "./DiscordTriggers.css";
import { BotTemplates } from "@dots-projects/types";

// export const triggerTemplates = [
//   {
//     name: "Public Channel Onboarding",
//     icon: <span className="mr-2">👋🏼</span>,
//     path: "public-onboarding",
//   },
//   {
//     name: "Support Ticket",
//     icon: <span className="mr-2">🎟️</span>,
//     path: "support-ticket",
//   },
//   {
//     name: "User Survey",
//     icon: <span className="mr-2">📊</span>,
//     path: "send-survey",
//   },
//   {
//     name: "Private Channel Onboarding",
//     icon: <span className="mr-2">🔒</span>,
//     path: "private-onboarding",
//   },
//   {
//     name: "Collect Email",
//     icon: <span className="mr-2">📧</span>,
//     path: "collect-email",
//   },
//   {
//     name: "Collect Feedback",
//     icon: <span className="mr-2">📝</span>,
//     path: "collect-feedback",
//   },
//   {
//     name: "Email Verification",
//     icon: <span className="mr-2">✅</span>,
//     path: "verify-email",
//   },
//   {
//     name: "Event RSVP",
//     icon: <span className="mr-2">🗓️</span>,
//     path: "event-rsvp",
//   },
// ];

export const getTriggerTemplates = (
  navigate: NavigateFunction,
  start: number,
  end: number,
  backgroundPosition: string[],
  botTemplates: BotTemplates[],
  customButtonStyle?: string
) => {
  const triggerButtonStyle =
    customButtonStyle ||
    "flex items-center rounded-md w-52 h-32 new-trigger-btn-shadow cursor-pointer overflow-hidden relative";
  return botTemplates.slice(start, end).map((temp, idx) => (
    <div
      className={`${triggerButtonStyle} template-background-img`}
      key={temp.name}
      style={{
        backgroundPosition: backgroundPosition[idx + 1],
      }}
      onClick={() => {
        window.analytics.track(
          `Templates Modal - new trigger template clicked: ${temp.slug}`
        );
        navigate(`/automation/new?type=${temp.slug}`);
      }}
    >
      <div className="blob-dark-blue-hover-full text-base text-center">
        <span className="m-0">
          {temp.emoji} {temp.name}
        </span>
      </div>
    </div>
  ));
};

/**
 * Component to display all the existing templates that we have
 */
export default function TriggerTemplates({
  backgroundPosition,
  botTemplates,
}: {
  backgroundPosition: string[];
  botTemplates: BotTemplates[];
}) {
  const navigate = useNavigate();

  return (
    <div className="flex gap-5 flex-wrap mt-10 mx-5 mb-48">
      {getTriggerTemplates(
        navigate,
        0,
        botTemplates.length,
        backgroundPosition,
        botTemplates
      )}
    </div>
  );
}
